import React, { useState, useContext, useEffect } from 'react';
import CloseButtonDialog from "App/components/CloseButtonDialog";
import {DialogActions,Typography,Grid,Button,TextField,MenuItem,InputAdornment,OutlinedInput,InputLabel,InputBase} from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import axios from 'axios';
import {DigitoVerificador} from 'App/Helpers/Genericos'
import { LayoutContext } from 'App/Layout/store'
import _ from 'underscore';

const styles = theme => ({
  table: {
    marginTop: 30,
  },
  gridContainer: {
    paddingRight: 30,
    marginTop: "0.1px"
  },
  borderRed: {
    borderStyle: "solid",
    marginTop: "0.1px",
    padding: 10,
    borderColor: "red"
  },
  labelPaddingTop: {
    paddingTop: "10px"
  }
});

function AgregarEditarEmpresa(props) {
    const { classes } = props;
    const [empresa,setEmpresa] = useState({})
    const [guardando,setGuardando] = useState(false)
    const layoutContext = useContext(LayoutContext);

    useEffect(()=>{
        setEmpresa(props.empresa)
        setGuardando(false)
    },[props.empresa])

    useEffect(()=>{
        if(!layoutContext.state.actividades.length){
            axios.get("/api/generico/actividades").then(actividades => layoutContext.dispatch(({type:'setActividades',actividades}))).catch(e => console.error(e))
        }
    },[])

    function guardaEmpresa(){
        setGuardando(true)
        axios.post("/api/Administracion/Empresas/AgregarOEditar",empresa).then(o => {
            alert("Cliente guardado exitosamente");
        }).catch(e => /*alert(e.response.data.Mensaje)*/{}).finally(()=>props.cerrar(true));
    }

    const content = empresa&&(
        <Grid container direction="column">
            <Grid item xs={12} sm>
            <Grid container spacing={0}>
            <Grid xs={3}>
                <TextField
                variant="outlined"
                label="RUT"
                type="number"
                disabled={(props.empresa||{}).Rut}
                fullWidth
                margin="normal"
                value={empresa.Rut||""}
                onChange={e=>{setEmpresa({...empresa,Rut:e.target.value})}}
                InputProps={{
                    endAdornment:<InputAdornment position="end"><div style={{width:"2rem"}}>- {DigitoVerificador((empresa.Rut||"").toString().replace(/[^\d]/g,''))}</div></InputAdornment>
                  }}
                />
                </Grid>
                <Grid xs={9}/>
                <Grid xs={8}>
                    <TextField
                        variant="outlined"
                        label="Razón Social"
                        fullWidth
                        value={empresa.RazonSocial||""}
                        onChange={e=>{setEmpresa({...empresa,RazonSocial:e.target.value})}}
                        margin="normal"
                    />
                </Grid>
                <Grid xs={4}/>
                <Grid xs={8}>
                    <TextField
                        variant="outlined"
                        label="Direccion"
                        fullWidth
                        value={empresa.Direccion||""}
                        onChange={e=>{setEmpresa({...empresa,Direccion:e.target.value})}}
                        margin="normal"
                    />
                </Grid>
                <Grid xs={1}/>
                <Grid xs={3}>
                    <TextField
                        variant="outlined"
                        label="Comuna"
                        fullWidth
                        value={empresa.Comuna||""}
                        onChange={e=>{setEmpresa({...empresa,Comuna:e.target.value})}}
                        margin="normal"
                    />
                </Grid>
                <Grid xs={5}>
                    <TextField
                        variant="outlined"
                        label="Correo"
                        fullWidth
                        value={empresa.Correo||""}
                        onChange={e=>{setEmpresa({...empresa,Correo:e.target.value})}}
                        margin="normal"
                    />
                </Grid>
                <Grid xs={7}/>
                <Grid xs={4}>
                    <TextField
                        select
                        variant="outlined"
                        label="Giro"
                        fullWidth
                        value={empresa.Giro||""}
                        onChange={e=>{setEmpresa({...empresa,Giro:e.target.value})}}
                        margin="normal"
                        SelectProps={{
                            native: true,
                          }}
                    >
                        <option key=""></option>
                        {layoutContext.state.actividades.map(option => (
                    <option key={option.Codigo} value={option.Codigo}>
                      {option.Codigo} - {option.Nombre}
                    </option>
                  ))}
                    </TextField>
                </Grid>
            </Grid>
            </Grid>
        </Grid>
    );

    const footer = (
        <DialogActions>
        <Button onClick={()=> { props.cerrar() }} color="primary">
            Cancelar
        </Button>
        <Button disabled={guardando} onClick={()=> guardaEmpresa()} color="primary" autoFocus>
            Guardar
        </Button>
        </DialogActions>
    );

    return (
        <div>
        <CloseButtonDialog open={props.empresa!==null} onClose={()=>props.cerrar()} closeButton title={_.isEmpty(props.empresa)?"Agregar Empresa":"Editar Empresa"} content={content} footer={footer} fullWidth fullHeight size="md" />
        </div>
    );
}

export default withStyles(styles)(AgregarEditarEmpresa);